import { render, staticRenderFns } from "./pd-microdata.vue?vue&type=template&id=1f4d867f&"
import script from "./pd-microdata.vue?vue&type=script&lang=js&"
export * from "./pd-microdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports